<script>
    import { ButtonGroup, Input, InputAddon, Label } from 'flowbite-svelte'
    import Typeahead from '$lib/components/Typeahead.svelte'

    export let label = ''
    export let labelFor = ''
    export let editing = false
    export let value = undefined
    export let data = undefined
    export let type = 'text'
    export let suffix = ''

    export let displayProperty = undefined

    export let extract = selected => selected

</script>
<div class="mb-4 flex gap-3 w-full">
    <Label for={labelFor} class="text-sm font-bold text-gray-700 dark:text-gray-300 w-1/2">
        <span>
            {label}
        </span>

    </Label>
    <div class="w-full flex justify-between font-light text-gray-600 text-sm">
        {#if editing}
            {#if $$slots["edit"]}
                <slot name="edit"></slot>
            {:else}
                {#if data}
                    <div class="w-full relative">
                        <Typeahead
                                {displayProperty}
                                bind:value={value}
                                data={data}
                                id={labelFor}
                                extract={extract} />

                    </div>

                {:else}
                    <ButtonGroup class="w-full">
                        <Input
                                class="w-full"
                                bind:value={value}
                                id={labelFor}
                                name={labelFor}
                                on:change={() => extract(value)}
                                type={type} />
                        {#if suffix}
                            <InputAddon>{suffix}</InputAddon>
                        {/if}
                    </ButtonGroup>
                {/if}
            {/if}
        {:else}
            <div class="font-light">
                <slot></slot>
            </div>
        {/if}
    </div>
</div>
